import React from 'react';
import Icon from '../components/icon';
import { i18n } from '../translate/i18n';

const setorName = 'content.department.department3';
const IGAUrl = 'https://iga.grupojacto.com.br/login';
const imgDitie = './ditie.ng';

const CardContent = [
  {
    id: 1,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title1'),
    subtitle: i18n.t('content.subtitle.subtitle1'),
    link: 'DITIE1',
    icon: <Icon name="SmartphoneRounded" />,
    img: imgDitie,
    children: [
      { id: 52, title: i18n.t('children.children1'), link: IGAUrl, img: <Icon name="KeyRounded" />, tool: 'IGA' },
      { id: 53, title: i18n.t('children.children2'), link: IGAUrl, img: <Icon name="KeyOffRounded" />, tool: 'IGA' },
      { id: 30, title: i18n.t('children.children3'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/30', img: <Icon name="LockRounded" />, tool: 'Jira' },
      { id: 55, title: i18n.t('children.children5'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/55', img: <Icon name="RestorePageRounded" />, tool: 'Jira' },
      { id: 57, title: i18n.t('children.children7'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/57', img: <Icon name="ErrorRounded" />, tool: 'Jira' },
      { id: 133, title: i18n.t('children.children133'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/133', img: <Icon name="UsbRounded" />, tool: 'Jira' },
      { id: 151, title: i18n.t('children.children151'), link: IGAUrl, img: <Icon name="DescriptionRounded" />, tool: 'IGA' },
      { id: 261, title: i18n.t('children.children261'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/261', img: <Icon name="SentimentSatisfiedRounded" />, tool: 'Jira' },
      { id: 791, title: i18n.t('children.children791'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/791', img: <Icon name="LockOpenRounded" />, tool: 'Jira' }
    ]
  },
  {
    id: 2,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title2'),
    subtitle: i18n.t('content.subtitle.subtitle2'),
    link: 'DITIE2',
    icon: <Icon name="DesktopMacRounded" />,
    img: imgDitie,
    children: [
      { id: 31, title: i18n.t('children.children8'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/31', img: <Icon name="ConstructionRounded" />, tool: 'Jira' },
      { id: 32, title: i18n.t('children.children9'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/32', img: <Icon name="DownloadRounded" />, tool: 'Jira' },
      { id: 45, title: i18n.t('children.children10'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/45', img: <Icon name="DesktopMacRounded" />, tool: 'Jira' },
      { id: 46, title: i18n.t('children.children11'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/46', img: <Icon name="AppSettingsAltRounded" />, tool: 'Jira' },
      { id: 47, title: i18n.t('children.children12'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/47', img: <Icon name="AddShoppingCartRounded" />, tool: 'Jira' },
      { id: 48, title: i18n.t('children.children13'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/48', img: <Icon name="HeadsetMicRounded" />, tool: 'Jira' },
      { id: 49, title: i18n.t('children.children14'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/49', img: <Icon name="BrowserUpdatedRounded" />, tool: 'Jira' },
      { id: 50, title: i18n.t('children.children15'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/50', img: <Icon name="PrintRounded" />, tool: 'Jira' },
      { id: 70, title: i18n.t('children.children16'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/70', img: <Icon name="SettingsRounded" />, tool: 'Jira' },
      { id: 132, title: i18n.t('children.children132'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/132', img: <Icon name="LiveHelpRounded" />, tool: 'Jira' },
      { id: 725, title: i18n.t('children.children725'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/44/create/725', img: <Icon name="InsertChartRounded" />, tool: 'Jira' }
    ]
  },
  {
    id: 3,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title3'),
    subtitle: i18n.t('content.subtitle.subtitle3'),
    link: 'DITIE3',
    icon: <Icon name="WifiRounded" />,
    img: imgDitie,
    children: [
      { id: 51, title: i18n.t('children.children17'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/51', img: <Icon name="WifiRounded" />, tool: 'Jira' },
      { id: 34, title: i18n.t('children.children18'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/34', img: <Icon name="SettingsInputComponentRounded" />, tool: 'Jira' },
      { id: 33, title: i18n.t('children.children19'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/33', img: <Icon name="WifiOffRounded" />, tool: 'Jira' },
    ]
  },
  {
    id: 4,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title4'),
    subtitle: i18n.t('content.subtitle.subtitle4'),
    link: 'DITIE4',
    icon: <Icon name="ConstructionRounded" />,
    img: imgDitie,
    children: [
      { id: 132, title: i18n.t('children.children132'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/132', img: <Icon name="LiveHelpRounded" />, tool: 'Jira' },
      { id: 37, title: i18n.t('children.children20'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/37', img: <Icon name="GroupsRounded" />, tool: 'Jira' },
      { id: 38, title: i18n.t('children.children21'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/38', img: <Icon name="StorageRounded" />, tool: 'Jira' },
      { id: 39, title: i18n.t('children.children22'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/39', img: <Icon name="LiveHelpRounded" />, tool: 'Jira' },
      { id: 41, title: i18n.t('children.children23'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/41', img: <Icon name="EmailRounded" />, tool: 'Jira' },
      { id: 42, title: i18n.t('children.children24'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/42', img: <Icon name="EmailRounded" />, tool: 'Jira' },
      { id: 43, title: i18n.t('children.children25'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/43', img: <Icon name="RoomPreferencesRounded" />, tool: 'Jira' },
      { id: 69, title: i18n.t('children.children69'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/69', img: <Icon name="RoomPreferencesRounded" />, tool: 'Jira' },
    ]
  },
  {
    id: 5,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title5'),
    subtitle: i18n.t('content.subtitle.subtitle5'),
    link: 'DITIE5',
    icon: <Icon name="LocalPhoneRounded" />,
    img: imgDitie,
    children: [
      //{ id: 26, title: i18n.t('children.children26'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3', img: <Icon name="PhoneForwardedRounded" />, tool: 'Jira' },
      { id: 166, title: i18n.t('children.children166'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/166', img: <Icon name="HeadphonesRounded" />, tool: 'Jira' },
      { id: 145, title: i18n.t('children.children46'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/145', img: <Icon name="HeadphonesRounded" />, tool: 'Jira' },
      { id: 130, title: i18n.t('children.children130'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/130', img: <Icon name="PhoneAndroidRounded" />, tool: 'Jira' },
      { id: 61, title: i18n.t('children.children27'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/61', img: <Icon name="AddIcCallRounded" />, tool: 'Jira' },
      { id: 62, title: i18n.t('children.children28'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/62', img: <Icon name="WifiCalling3Rounded" />, tool: 'Jira' },
      { id: 63, title: i18n.t('children.children29'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/63', img: <Icon name="PhoneDisabledRounded" />, tool: 'Jira' },
      { id: 64, title: i18n.t('children.children30'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/64', img: <Icon name="AutorenewRounded" />, tool: 'Jira' },
    ]
  },
  {
    id: 6,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title6'),
    subtitle: i18n.t('content.subtitle.subtitle6'),
    link: 'DITIE6',
    icon: <Icon name="GroupsRounded" />,
    img: imgDitie,
    children: [
      { id: 40, title: i18n.t('children.children31'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/40', img: <Icon name="AddCommentRounded" />, tool: 'Jira' },
      { id: 65, title: i18n.t('children.children32'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/65', img: <Icon name="CancelRounded" />, tool: 'Jira' },
      { id: 66, title: i18n.t('children.children33'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/66', img: <Icon name="MoveDownRounded" />, tool: 'Jira' },
      { id: 67, title: i18n.t('children.children34'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/67', img: <Icon name="AssessmentRounded" />, tool: 'Jira' },
      { id: 863, title: i18n.t('children.children863'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/863', img: <Icon name="AutoAwesomeRounded" />, tool: 'Jira' },
      { id: 896, title: i18n.t('children.children896'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/44/create/896', img: <Icon name="CodeRounded" />, tool: 'Jira' },
      //{ id: 35, title: i18n.t('children.children35'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3', img: <Icon name="ShoppingCartRounded" />, tool: 'Jira' },
    ]
  },
  {
    id: 7,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title7'),
    subtitle: i18n.t('content.subtitle.subtitle7'),
    link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/44/create/558',
    icon: <Icon name="SettingsSuggestRounded" />,
    img: <Icon name="SettingsSuggestRounded" />,
    children: []
  },
  {
    id: 10,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title10'),
    subtitle: i18n.t('content.subtitle.subtitle10'),
    link: 'DITIE10',
    icon: <Icon name="SupportAgentRounded" />,
    img: imgDitie,
    children: [
      { id: 73, title: i18n.t('children.children43'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/73', img: <Icon name="VideocamOffRounded" />, tool: 'Jira' },
      { id: 72, title: i18n.t('children.children44'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/72', img: <Icon name="SmsFailedRounded" />, tool: 'Jira' },
      { id: 71, title: i18n.t('children.children45'), link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/71', img: <Icon name="SettingsRounded" />, tool: 'Jira' },
    ]
  },
  {
    id: 11,
    setor: i18n.t(setorName),
    highlight: true,
    title: i18n.t('content.title.title11'),
    subtitle: i18n.t('content.subtitle.subtitle11'),
    link: 'https://grupojacto.atlassian.net/servicedesk/customer/portal/3/create/657',
    icon: <Icon name="CloudRounded" />,
    img: <Icon name="CloudRounded" />,
    children: []
  }
]

const children = CardContent.map((dict) => dict.children || [])
export const AllChildren = children.flat();

export const AllParents = CardContent;

export default CardContent;
